import React, {PureComponent, cloneElement} from 'react'
import Modal from 'components/common/Modal/Modal'
import cn from 'classnames'
import ImportModal from './Modal'

class ImportTrigger extends PureComponent {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }

  handleModal(isOpen) {
    //this.props.setPopoverStable(isOpen);
    this.setState({isOpen});
  }

  render() {
    return (
      <div className={ this.props.className } id={ this.props.id } >
        {cloneElement(this.props.children, {
          onClick: () => this.handleModal(true),
        })}
        <Modal label={'Import'}
               closeModal={ () => {this.props.onHide(); this.handleModal(false)} }
               isOpen={this.state.isOpen}>
          <ImportModal />
        </Modal>
      </div>
    )
  }
}

ImportTrigger.propTypes = {
};

export default ImportTrigger;
